import "./App.css"
import AuthProvider from "./components/auth/AuthProvider"
import ThemeConfig from "./components/library/theme"
import GlobalStyles from "./components/library/theme/globalStyles"
import NotiStackProvider from "./components/NotistackProvider"

import { GoogleOAuthProvider } from "@react-oauth/google"
// import { clarity } from 'react-microsoft-clarity'
import Cookies from "js-cookie"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import ThemePrimaryColor from "./components/ThemePrimaryColor"
import Router from "./routers"
// clarity.init('ob527b6ne4')
function App() {
  const navigate = useNavigate()

  useEffect(() => {
    const token = Cookies.get("hrme_token")
    if (!token) {
      navigate("/login")
    }
  }, [navigate])

  return (
    <ThemeConfig>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ""}>
        <AuthProvider>
          <NotiStackProvider>
            <ThemePrimaryColor>
              <GlobalStyles />
              {/* <Settings /> */}
              <Router />
            </ThemePrimaryColor>
          </NotiStackProvider>
        </AuthProvider>
      </GoogleOAuthProvider>
    </ThemeConfig>
  )
}

export default App
